import {CALL_API, Call} from 'redux/middleware/api'
import {getSelectedDateRange, getAggregatedSites} from 'redux/modules/currentUser/selectors'
import {reportError} from 'redux/modules/error/actions'
import {batchActions} from 'redux-batch-enhancer'
import {
  ANALYTICS_DATA,
  ANALYTICS_DIMENSIONS,
  ANALYTICS_DATA_TOTAL,
  ANALYTICS_CHART_DATA,
  ANALYTICS_CLEAR_METRICS,
  ANALYTICS_REMOVE_PLOTTED_METRIC,
  ANALYTICS_ADD_CHART
} from './'
import formatDateWithTz from 'utils/formatDateWithTz'
import {dateDimentions} from '../../../utils/dimensions'
const statsVersion = localStorage.getItem('statsVersion') === 'v1' ? '' : 'v2/'

function loadAnalyticsData({
  merchantSiteId, targetCurrency, startDate, endDate, dimensions, metrics, filters, timezone
}) {

  const dateDimentionsSorting = dimensions.reduce((acc, d) => {
    if (dateDimentions.includes(d)) {
      acc[d] = 'desc'
    }
    return acc
  }, {})

  const metricsSorting = metrics.reduce((acc, m) => {
    acc[m] = 'desc'
    return acc
  }, dateDimentionsSorting)

  return {
    [CALL_API]: {
      endpoint: `${statsVersion}stats`,
      types: ANALYTICS_DATA,
      queryParams: {
        merchantSiteId,
        targetCurrency,
        range: {
          start: startDate,
          end: endDate
        },
        dimensions,
        metrics,
        sort: metricsSorting,
        filter: filters,
        timeUnit: 'total',
        timezone
      }
    }
  }
}

function fetchAvailableDimensions({
  merchantSiteId, targetCurrency, startDate, endDate, dimensions, metrics, timezone
}) {
  return {
    [CALL_API]: {
      endpoint: `${statsVersion}stats`,
      types: ANALYTICS_DIMENSIONS,
      queryParams: {
        merchantSiteId,
        targetCurrency,
        range: {
          start: startDate,
          end: endDate
        },
        dimensions,
        metrics,
        timeUnit: 'total',
        timezone
      }
    }
  }
}

function loadAnalyticsDataTotal({merchantSiteId, targetCurrency, startDate, endDate, metrics, filters, timezone}) {
  return {
    [CALL_API]: {
      endpoint: `${statsVersion}stats`,
      types: ANALYTICS_DATA_TOTAL,
      queryParams: {
        merchantSiteId,
        targetCurrency,
        range: {
          start: startDate,
          end: endDate
        },
        metrics,
        filter: filters,
        timeUnit: 'total',
        timezone
      }
    }
  }
}

function loadAnalyticsGraphData({
  merchantSiteId, targetCurrency, startDate, endDate, dimensions, metrics, filter, timezone
}) {
  return {
    [CALL_API]: {
      endpoint: `${statsVersion}stats`,
      types: ANALYTICS_CHART_DATA,
      queryParams: {
        merchantSiteId,
        targetCurrency,
        range: {
          start: startDate,
          end: endDate
        },
        dimensions,
        metrics,
        filter,
        timeUnit: 'day',
        timezone
      },
      params: {
        metric: metrics[0],
        dimension: filter
      }
    }
  }
}

function fetchAnalyticsChartData(metric, dimension, targetCurrency, timezone, crossSiteMode) {
  return (dispatch, getState) => new Call((success, fail) => {
    const state = getState()
    const sites = getAggregatedSites(state, crossSiteMode)
    const dimensions = dimension.map(dimension => Object.keys(dimension)[0])
    const {startDate, endDate} = getSelectedDateRange(getState())
    const fetchParams = {
      merchantSiteId: sites,
      targetCurrency,
      startDate: formatDateWithTz(startDate, timezone),
      endDate: formatDateWithTz(endDate, timezone),
      dimensions,
      metrics: [metric],
      filter: dimension,
      timezone
    }
    dispatch(loadAnalyticsGraphData(fetchParams))
      .success(success)
      .fail(fail)
      .fail(dispatch(reportError()))
  })
}

export function fetchAnalyticsData(
  startDate,
  endDate,
  dimensions,
  metrics,
  filters,
  targetCurrency,
  timezone,
  crossSiteMode
) {
  if (metrics.length === 0) {
    return {type: ANALYTICS_CLEAR_METRICS}
  }

  return (dispatch, getState) => {
    const state = getState()
    const sites = getAggregatedSites(state, crossSiteMode)
    const fetchParams = {
      merchantSiteId: sites,
      targetCurrency,
      startDate: formatDateWithTz(startDate, timezone),
      endDate: formatDateWithTz(endDate, timezone),
      dimensions,
      metrics,
      filters,
      timezone
    }

    dispatch(loadAnalyticsData(fetchParams))
      .success(() => {
        dispatch(fetchAvailableDimensions(fetchParams))
        dispatch(loadAnalyticsDataTotal(fetchParams))
        const {charts} = getState().analytics
        const chartDataActions = []
        charts.forEach(({dimensions, metric}) => {
          dimensions.forEach(dimension => {
            chartDataActions.push(fetchAnalyticsChartData(metric, dimension, targetCurrency, timezone, crossSiteMode))
          })
        })
        if (chartDataActions.length > 0) {
          Call.all(dispatch(batchActions(chartDataActions)))
            .fail(dispatch(reportError()))
        }
      })
      .fail(dispatch(reportError()))
  }
}

export function addChart(metric, dimension, targetCurrency, timezone, crossSiteMode) {
  return (dispatch, getState) => {
    if (dimension && dimension.length === 0) {
      dimension = []
    }
    dispatch({
      type: ANALYTICS_ADD_CHART,
      metric,
      dimension
    })
    dispatch(fetchAnalyticsChartData(metric, dimension, targetCurrency, timezone, crossSiteMode))
  }
}

export function removePlottedMetric(metric, dimension) {
  return {
    type: ANALYTICS_REMOVE_PLOTTED_METRIC,
    metric,
    dimension
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/analytics/actions.js